import React from 'react';

const LivestreamingBlur = () => {
	return <div>LivestreamingBlur</div>;
};

export default LivestreamingBlur;
